export const INITIAL_STATE = {
  isList: false,
  sortMode: "name",
  filter: "",
};
